// eslint-disable-next-line import/no-anonymous-default-export
export default {
  add: 'Ekle',
  edit: 'Düzenle',
  delete: 'Sil',
  save: 'Kaydet',
  cancel: 'İptal',
  close: 'Kapat',
  search: 'Ara',
  filter: 'Filtrele',
  export: 'Dışa Aktar',
  import: 'İçe Aktar',
  loading: 'Yükleniyor...',
  saving: 'Kaydediliyor...',
  noData: 'Veri bulunamadı',
  actions: 'İşlemler',
  status: 'Durum',
  active: 'Aktif',
  passive: 'Pasif',
  inactive: 'Pasif',
  yes: 'Evet',
  no: 'Hayır',
  all: 'Tümü',
  update: 'Güncelle',
  view: 'Görüntüle',
  details: 'Detaylar',
  description: 'Açıklama',
  notes: 'Notlar',
  date: 'Tarih',
  amount: 'Tutar',
  currency: 'Para Birimi',
  name: 'Ad',
  email: 'E-posta',
  phone: 'Telefon',
  address: 'Adres',
  website: 'Website',
  type: 'Tip',
  price: 'Fiyat',
  purchasePrice: 'Alış Fiyatı',
  salePrice: 'Satış Fiyatı',
  profit: 'Kar',
  total: 'Toplam',
  monthly: 'Aylık',
  yearly: 'Yıllık',
  oneTime: 'Tek Seferlik',
  startDate: 'Başlangıç Tarihi',
  endDate: 'Bitiş Tarihi',
  registrationDate: 'Kayıt Tarihi',
  expiryDate: 'Son Kullanma Tarihi',
  createdAt: 'Oluşturulma Tarihi',
  updatedAt: 'Güncellenme Tarihi',
  unknownError: 'Bilinmeyen hata',
  success: 'Başarılı',
  error: 'Hata',
  warning: 'Uyarı',
  info: 'Bilgi',
  confirm: 'Onayla',
  confirmDelete: 'Silmek istediğinizden emin misiniz?',
  searchPlaceholder: 'Ara...',
  noResults: 'Sonuç bulunamadı',
  required: 'Zorunlu',
  optional: 'Opsiyonel',
  select: 'Seçin',
  selectAll: 'Tümünü Seç',
  deselectAll: 'Tümünü Kaldır',
  showing: 'Gösteriliyor',
  of: 'toplam',
  page: 'Sayfa',
  perPage: 'Sayfa başına',
  previous: 'Önceki',
  next: 'Sonraki',
  first: 'İlk',
  last: 'Son',
  locale: 'tr-TR',
  typeDomain: 'Domain',
  typeHosting: 'Hosting',
  typeSsl: 'SSL',
  typeEmail: 'E-posta',
  typeReklam: 'Reklam',
  typeDanismanlik: 'Danışmanlık',
  typeOther: 'Diğer',
  connectorInfo: 'Ödeme bağlayıcısı firma üzerinden kurulmaktadır.',
  newRecurringPayment: 'Yeni Tekrarlı Ödeme',
  editRecurringPayment: 'Tekrarlı Ödeme Düzenle',
  company: 'Şirket',
  selectCompany: 'Şirket Seçin',
  packageType: 'Paket Tipi',
  selectHostingPackage: 'Hosting Paketi Seçin',
  manualEntry: 'Manuel giriş yap',
  noHostingPrice: 'Fiyat tanımlanmamış',
  packageName: 'Paket Adı',
  examplePackage: 'Örn: Domain Paketi',
  getDomainPrice: 'Fiyat',
  selectDomain: 'Domain Seçin',
  selectDomainOptional: 'Domain Seçin (Opsiyonel)',
  getDatesFromWhois: 'WHOIS',
  whois: 'WHOIS',
  noDomainFound: 'Domain bulunamadı',
  paymentProbability: 'Ödeme İhtimali',
  paymentProbabilityHint: '0-100 arası',
  nextPayment: 'Sonraki Ödeme',
  additionalNotes: 'Ek notlar...',
  addPayment: 'Ödeme Ekle',
  clear: 'Temizle',
  groupByCompany: 'Firmalara Göre Grupla',
  payments: 'ödeme',
  totalPurchase: 'Toplam Alış',
  totalSale: 'Toplam Satış',
  totalProfitLoss: 'Toplam Kar/Zarar',
  purchase: 'Alış',
  sale: 'Satış',
  daysLeft: 'gün kaldı',
  daysPast: 'gün geçti',
  na: 'N/A',
  extendPeriod: 'Süreyi Uzat',
  package: 'Paket',
  productService: 'Ürün / Hizmet',
  nextPaymentDate: 'Sonraki Ödeme Tarihi',
  delayed: 'Gecikmiş',
  days: 'gün',
  noResultsFound: 'Filtreye uygun ödeme bulunamadı',
  tryDifferentFilter: 'Farklı bir firma seçin veya filtreyi temizleyin.',
  addFirstItem: 'İlk öğeyi ekleyerek başlayın.',
  more: 'daha',
  selectDate: 'Bir gün seçin'
};
